import React from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/style/colors";
import TitleDescriptionCard from "../generic/TitleDescriptionCard";
import { ReactComponent as ForkIcon3Long } from "../../assets/icons/Fork3Long.svg";
import { ReactComponent as ForkIcon4Long } from "../../assets/icons/Fork4Long.svg";
import { useNavigate } from "react-router-dom";

const AppGrowData = () => {
  const navigate = useNavigate();
  const block1 = [
    {
      title: "Attract More Users",
      description:
        "Easily identify your highest-performing channels and campaigns. Grovs clearly tracks installs, re-installs, and reactivations so you can focus your budget on what truly works.",
      learnMore: () => navigate("/measure"),
    },

    {
      title: "Improve User Engagement",
      description:
        "Send users straight to the most relevant content every time using intelligent deep linking. Guide users through seamless journeys across any device, enhancing their experience and boosting conversion rates.",
      learnMore: () => navigate("/engagement"),
    },

    {
      title: "Maximize Lifetime Value (LTV)",
      description:
        "Create personalized user experiences with platform-specific messaging, encouraging consistent engagement, improved retention, and higher user lifetime value.",
      learnMore: () => navigate("/increase-engagement"),
    },
  ];
  const block2 = [
    {
      title: "Intelligent Campaign Tracking",
      description:
        "Stop guessing and start knowing with automatic tracking from click to conversion, real-time campaign insights, and simple, clear attribution reporting.",
      learnMore: () => navigate("/measure"),
    },

    {
      title: "Smart, Editable Deep Links",
      description:
        "Eliminate friction with smart deep linking that routes users to the right content, supports seamless post-install journeys, and offers fully editable, trackable links.",
      learnMore: () => navigate("/engagement"),
    },

    {
      title: "Automated Cross-Platform Messaging",
      description:
        "Keep users engaged with automated messaging tailored by platform and user type—without overwhelming them.",
      learnMore: () => navigate("/messaging"),
    },
    {
      title: "Easy-to-Use, Unified Dashboard",
      description:
        "No more confusing dashboards—just clear insights at a glance. Track performance across channels, export data easily, and see what’s driving growth.",
      learnMore: () => navigate("/analyse"),
    },
  ];
  return (
    <FullPageContainer>
      <Container>
        <Content>
          <TextWrapper>
            <Title>Why Choose Grovs for App Growth?</Title>
            <Subtitle>
              Grovs gives marketers and product teams everything needed to drive
              installs, boost engagement, and maximize ROI with clarity and
              ease.
            </Subtitle>
          </TextWrapper>
          <RightSide>
            <ForkWrapper>
              <ForkIcon3Long
                color={lightThemeColors.landingPagePrimaryBackground}
              />
            </ForkWrapper>
            <ItemsWrapper>
              {block1.map((item, index) => (
                <TitleDescriptionCard
                  key={index}
                  title={item.title}
                  description={item.description}
                  learnMore={item.learnMore}
                />
              ))}
            </ItemsWrapper>
          </RightSide>
        </Content>
        <Content>
          <TextWrapper>
            <Title>Everything You Need for App Growth in One Platform</Title>
            <Subtitle>
              Grovs' smart links provide reliable insights into user flows,
              eliminating guesswork and clearly mapping journeys. Make informed
              decisions with complete visibility into user experiences.
            </Subtitle>
          </TextWrapper>
          <RightSide>
            <ForkWrapper>
              <ForkIcon4Long
                color={lightThemeColors.landingPagePrimaryBackground}
              />
            </ForkWrapper>
            <ItemsWrapper>
              {block2.map((item, index) => (
                <TitleDescriptionCard
                  key={index}
                  title={item.title}
                  description={item.description}
                  learnMore={item.learnMore}
                />
              ))}
            </ItemsWrapper>
          </RightSide>
        </Content>
      </Container>
    </FullPageContainer>
  );
};

export default AppGrowData;
const FullPageContainer = styled.div`
  display: flex;
  width: 100%;
  background: ${lightThemeColors.background};
  position: relative;
`;

const Container = styled.div`
  width: 100%;
  max-width: 1512px;
  margin-left: auto;
  margin-right: auto;
  z-index: 1;
  display: flex;
  flex-direction: column;
  padding: 100px 80px;
  gap: 100px;
  @media (max-width: 990px) {
    padding: 20px;
    gap: 30px;
  }
`;
const Content = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  gap: 30px;
  align-items: center;
  @media (max-width: 990px) {
    flex-direction: column;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  width: 100%;
  gap: 30px;
  max-width: 850px;
`;

const Title = styled.h1`
  color: ${lightThemeColors.darkColor};
  font-size: 36px;
  font-weight: 700;
  line-height: 46px;
  @media (max-width: 990px) {
    font-size: 30px;
    line-height: 36px;
    text-align: center;
  }
`;
const Subtitle = styled.p`
  color: ${lightThemeColors.darkColorFaded};
  font-size: 18px;
  font-weight: 400;
  line-height: 28px;
`;

const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
  overflow: hidden;
`;
const RightSide = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  gap: 10px;
`;
const ForkWrapper = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  @media (max-width: 990px) {
    display: none;
  }
`;
